module.exports = __webpack_public_path__ + "3bc13b22deac6417090bf5ae00daed7f.svg";